function isFunction(functionToCheck) {
	return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

export const setValidationTypeProperty = function(validation, validationType) {
	if (isFunction(validation)) {
		validation.validationType = validationType;
	}
    return validation;
}

export const enableCustomValidationMessaging = function(validation) {
	if (isFunction(validation)) {
		validation.locale = customMessages => (value, field, model) => validation(value, field, model, customMessages);
	}
    return validation;
}


export const setCustomValidationProperties = function(validation, validationType) {

	//always set validation type first. Used instead of native
	//javascript function object property 'name' because name
	//is getting compressed in bundle
	validation = setValidationTypeProperty(validation, validationType);

	//enable custom validation messaging
	validation = enableCustomValidationMessaging(validation);
	return validation;
}
